import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";

import { useRecruiterBookingFlowContext } from "../../hooks/useRecruiterBookingFlowContext";

export function RecruiterScreeningBookingLandingActions() {
  const bookingFlowState = useRecruiterBookingFlowContext();

  const onCallMeNowSelected = () => {
    bookingFlowState.setPath("call-me-now");
    bookingFlowState.setStage("contact-details");
  };

  const onScheduleForLaterSelected = () => {
    // Until we have the native booking flow, we will open the calendly link for scheduling
    void bookingFlowState.onScheduleForLater();
  };

  return (
    <Stack spacing={4} width="100%">
      {/* For the initial rollout, we are unsure if we can handle the full volume of calls. So we are only going to serve this variation to a limited number of users */}
      {bookingFlowState.screeningConfig.showCallMeNow && (
        <Button fullWidth variant="contained" size="large" onClick={onCallMeNowSelected}>
          Call me now
        </Button>
      )}
      <Button fullWidth variant="outlined" size="large" onClick={onScheduleForLaterSelected}>
        Schedule for later
      </Button>
    </Stack>
  );
}
